export async function deleteAttachment(id, aid) {
  const response = await fetch(`/api/deleteAttachment?id=${id}&aid=${aid}`, {
    method: "POST",
  });

  if (!response.ok) {
    throw new Error(`deleteAttachment failed: ${response.statusText}`);
  }
}

export async function getBlob(container, blob) {
  const response = await fetch(
    `/api/getBlob?container=${container}&blob=${blob}`,
    {
      method: "GET",
    }
  );

  if (!response.ok) {
    throw new Error(`getBlob failed: ${response.statusText}`);
  }

  return await response.blob();
}

export async function saveEDSSCase(payload) {
  const response = await fetch("/api/saveEDSSCase", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`saveEDSSCase failed: ${response.statusText}`);
  }
}

export async function writeAttachment(caseId, file) {
  const response = await fetch(`/api/writeAttachment?id=${caseId}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/octet-stream",
    },
    body: file,
  });

  if (!response.ok) {
    throw new Error(`writeAttachment failed: ${response.statusText}`);
  }

  return await response.text();
}
